export default (link: string) => {
  if (!link) return link;
  if (link.slice(0, 4) !== 'http') {
    return `http://${link}`;
  } else {
    return link;
  }
};
